import { TextHeadline1 } from '@blocket/blocket-ui'
import ColorBar from '@blocket/blocket-ui/lib/commonjs/components/TabBar/ColorBar'
import pulse from '@blocket/tracking-pulse'
import Header from 'components/Header'
import VerificationModal from 'components/Modal/VerificationModal'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actionCreators as selectAdInsertionActionCreators } from 'reduxBits/selectAdInsertion/actions'
import { getPulseOrigin } from 'utils/pulse'
import { get } from 'lodash'
import {
  BusinessCard,
  CarCard,
  ElectronicCard,
  HobbyCard,
  HomeCard,
  OtherCard,
  PersonalCard,
  ResidenceCardNew,
} from './Cards'
import  CompanyBlueInfoBox, { CompanyAdInsertionLink }  from './CompanyAdInsertionLink'
import { ColoredResponsivePage, ContentWrap, FullHeightWrapper } from './layout'
import { setupAndShowCookieConsentModal } from '../../../utils/schibstedCookieConsent'
export class SelectFlowComponent extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      width: undefined,
    }
  }

  componentDidMount() {
    pulse.pageView({
      type: 'View',
      object: {
        type: 'Page',
        name: 'Slussen',
        id: 'slussen-page',
      },
      origin: getPulseOrigin(),
    })

    if (typeof window !== 'undefined') {
      // Handler to call on window resize
      const handleResize = () => {
        // Set window width/height to state
        this.setState({
          width: window.innerWidth,
        })
      }

      // Add event listener
      window.addEventListener('resize', handleResize)

      // Call handler right away so state gets updated with initial window size
      handleResize()

      const { userId, environment } = this.props
      setupAndShowCookieConsentModal(userId, environment)
    }
  }

  render() {
    const { selectAdInsertionActions, verificationModalType, verificationRedirectUri } = this.props

    const { width } = this.state

    return (
      <FullHeightWrapper>
        <ColorBar />
        <Header
          cancelBtnText="Avbryt"
          cancelBtnEvent={async () => {
            await selectAdInsertionActions.selectAdInsertionInteraction({
              id: 'cancel',
              url: window.location.href,
            })
            window.location.href = '/'
          }}
        />
        {!!verificationModalType && (
          <VerificationModal
            tag="new_slussen"
            redirectUri={verificationRedirectUri}
            cancelUri="/mina-annonser/lagg-in-annons"
          />
        )}
        <ColoredResponsivePage mobileMaxWidth={980} desktopMaxWidth={980}>
          <TextHeadline1>Vad vill du annonsera?</TextHeadline1>
          {width < 768 && (
            <CompanyBlueInfoBox />
          )}
          <CompanyAdInsertionLink />
          <ContentWrap>
            {width < 768 ? (
              // mobile
              <>
                <HomeCard />
                <CarCard />
                <HobbyCard />
                <ElectronicCard />
                <PersonalCard />
                <ResidenceCardNew/>
                <BusinessCard />
                <OtherCard />
              </>
            ) : (
              // desktop
              <>
                <HomeCard />
                <HobbyCard />
                <ElectronicCard />
                <PersonalCard />
                <OtherCard />
                <CarCard />
                <ResidenceCardNew/>
                <BusinessCard />
              </>
            )}
          </ContentWrap>
          {width > 768 && (
            <CompanyBlueInfoBox />
          )}
        </ColoredResponsivePage>
      </FullHeightWrapper>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectAdInsertionActions: bindActionCreators(selectAdInsertionActionCreators, dispatch),
})

const mapStateToProps = (state) => ({
  verificationModalType: state.verification.modal?.type,
  verificationRedirectUri: state.verification.modal?.redirectUri,
  userId: get(state, 'user.id', '0'),
  environment: state.config.environment
})

SelectFlowComponent.propTypes = {
  selectAdInsertionActions: PropTypes.object.isRequired,
  verificationModalType: PropTypes.string,
  verificationRedirectUri: PropTypes.string,
  userId: PropTypes.string,
  environment: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectFlowComponent)
